module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-container"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/service_question"
    }
  }, [_vm._v(_vm._s(_vm.$t('Service Questions')))])], 1), _vm._m(0)]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "video-section"
  }, [_c('h3', [_vm._v("最新動画")]), _c('div', {
    staticClass: "video-display"
  }, [(_vm.newMovieExists) ? _c('video', {
    staticClass: "video-player",
    attrs: {
      "controls": "controls",
      "src": _vm.newMovieUrl
    },
    on: {
      "error": _vm.onNewMovieError
    }
  }) : _c('div', {
    staticClass: "video-placeholder"
  }, [_vm._v("動画がありません")])]), _c('div', {
    staticClass: "upload-section"
  }, [_c('div', {
    staticClass: "file-input"
  }, [_c('input', {
    ref: "newMovieInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": _vm.onNewMovieFileChange
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.selectNewMovieFile
    }
  }, [_vm._v("ファイル選択")]), (_vm.newMovieFile) ? _c('div', {
    staticClass: "file-selected-message",
    staticStyle: {
      "color": "red",
      "margin-top": "5px",
      "font-size": "14px"
    }
  }, [_vm._v("更新してよければアップロードを実行してください")]) : _vm._e()]), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.newMovieFile || _vm.uploading
    },
    on: {
      "click": _vm.uploadNewMovie
    }
  }, [(!_vm.uploading) ? _c('i', {
    staticClass: "fa fa-upload"
  }) : _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v(" アップロード")])]), (_vm.newMovieExists) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.deleting
    },
    on: {
      "click": _vm.deleteNewMovie
    }
  }, [(!_vm.deleting) ? _c('i', {
    staticClass: "fa fa-trash"
  }) : _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v(" 削除")])]) : _vm._e()])])])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "video-section"
  }, [_c('h3', [_vm._v("オススメ動画")]), _c('div', {
    staticClass: "video-display"
  }, [(_vm.recommendMovieExists) ? _c('video', {
    staticClass: "video-player",
    attrs: {
      "controls": "controls",
      "src": _vm.recommendMovieUrl
    },
    on: {
      "error": _vm.onRecommendMovieError
    }
  }) : _c('div', {
    staticClass: "video-placeholder"
  }, [_vm._v("動画がありません")])]), _c('div', {
    staticClass: "upload-section"
  }, [_c('div', {
    staticClass: "file-input"
  }, [_c('input', {
    ref: "recommendMovieInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": _vm.onRecommendMovieFileChange
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.selectRecommendMovieFile
    }
  }, [_vm._v("ファイル選択")]), (_vm.recommendMovieFile) ? _c('div', {
    staticClass: "file-selected-message",
    staticStyle: {
      "color": "red",
      "margin-top": "5px",
      "font-size": "14px"
    }
  }, [_vm._v("更新してよければアップロードを実行してください")]) : _vm._e()]), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.recommendMovieFile || _vm.uploading
    },
    on: {
      "click": _vm.uploadRecommendMovie
    }
  }, [(!_vm.uploading) ? _c('i', {
    staticClass: "fa fa-upload"
  }) : _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v(" アップロード")])]), (_vm.recommendMovieExists) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.deleting
    },
    on: {
      "click": _vm.deleteRecommendMovie
    }
  }, [(!_vm.deleting) ? _c('i', {
    staticClass: "fa fa-trash"
  }) : _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v(" 削除")])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v("動画ファイル管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17c08eea!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/service-question-movie.pug
// module id = 794
// module chunks = 1